import { type ReactNode } from "react";
import { SiteLegalFooter } from "@/components/layout/site-legal-footer";

/** Centered auth card layout with compact legal footer. */
export function AuthPageShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-orange-50 to-white">
      <div className="flex-1 flex items-center justify-center p-4">{children}</div>
      <SiteLegalFooter />
    </div>
  );
}
